import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class LoggerUserDataChangedNotificationService {
	isLoggedUserDataChanged: boolean;

	loggedUserDataChanged: Subject<boolean> = new Subject<boolean>();

	constructor() {
		this.loggedUserDataChanged.subscribe((value) => {
			this.isLoggedUserDataChanged = value;
		});
	}

	informLoggedUserDataChanged(value: boolean) {
		this.loggedUserDataChanged.next(value);
	}
}
